import PropTypes from 'prop-types';
import React from 'react';
import { Col } from 'react-bootstrap';

import { NumberField } from 'Shared/form/NumberField';
import withFormikFields from 'Shared/form/withFormikFields';
import CommonPatientFieldWrapper from '../CommonPatientFieldWrapper';

const WeightField = ({ fieldValues: { weight } }) => {
    return (
        <CommonPatientFieldWrapper fieldName="weight">
            {(commonProps) => (
                <Col md={3}>
                    <NumberField
                        {...commonProps}
                        placeholder="Weight in Pounds"
                        label={
                            <>
                                <span>Weight (Pounds)</span>
                                {weight > 0 && <span className="float-right">{(weight * 0.453592).toFixed(1)} kg</span>}
                            </>
                        }
                    />
                </Col>
            )}
        </CommonPatientFieldWrapper>
    );
};

WeightField.propTypes = {
    fieldValues: PropTypes.shape({
        weight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    }).isRequired,
};

export default withFormikFields({ WrappedComponent: WeightField, fieldNames: ['weight'] });
